var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6e475d263361177d3f7d664189baceb8264061c9"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN || 'https://581d96461757b7e9fad0d2b959e1fa83@sentry-next.pinchos.se/3',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.2,

    // Limit how deep Sentry's own normalization recurses when serializing
    // breadcrumb / context data. Objects coming from 3rd-party scripts
    // (GTM `dataLayer`, the consent manager, etc.) frequently contain
    // circular references; the default depth of 3 can still blow the
    // call stack when those objects are very wide, surfacing as
    // "RangeError: Maximum call stack size exceeded" with an empty
    // stack trace like `at ? (undefined:38:249)`.
    normalizeDepth: 5,
    normalizeMaxBreadth: 50,

    // Drop errors that originate in scripts we don't ship and can't fix.
    // The booking client embeds Consent Manager, Google Tag Manager,
    // Cloudflare Turnstile, Hotjar (via env), Vercel Analytics/Insights
    // and Sanity – all of which occasionally throw inside their own
    // bundles. Those reports are not actionable for us and mostly add
    // noise (and quota usage).
    denyUrls: [
      /delivery\.consentmanager\.net/i,
      /cdn\.consentmanager\.net/i,
      /googletagmanager\.com/i,
      /google-analytics\.com/i,
      /challenges\.cloudflare\.com/i,
      /static\.hotjar\.com/i,
      /script\.hotjar\.com/i,
      /vitals\.vercel-insights\.com/i,
      /\/_vercel\/insights\//i,
      /apicdn\.sanity\.io/i,
      // Browser extensions
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /^safari-web-extension:\/\//i,
    ],

    // Common unactionable errors. Anything matching here is dropped
    // before being sent. The `Maximum call stack size exceeded` entry
    // specifically targets the recursion-during-serialization class of
    // bug above; if the same message starts showing up again with a
    // meaningful stack trace (i.e. frames from our own code), we'll
    // want to re-enable it and fix the real cause.
    ignoreErrors: [
      // Network-only, expected from flaky mobile connections
      'NetworkError',
      'Network request failed',
      'Failed to fetch',
      'Load failed',
      // ResizeObserver loop limit reached – Chrome quirk, harmless
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Random non-Error throws from 3rd-party code (Promise rejections
      // that aren't real Errors carry no useful stack).
      'Non-Error promise rejection captured',
      // Self-recursion in Sentry's own normalize() / 3rd-party scripts.
      // We re-evaluate this filter whenever we get a real, sourcemapped
      // stack trace for one of these errors.
      'Maximum call stack size exceeded',
    ],

    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
}
